import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Element } from 'react-scroll';
import heroImage from '../Assets/homepage.jpg'; // Update this path to your actual image
import '../Styles/MainStyles/HomePage.css'; // Create this file for custom styles
import Contact from './Contact';
import Features from './Features';
import Overview from './Overview';
import Pricing from './Pricing';
import { useNavigate } from 'react-router-dom';


const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="homepage">
      {/* Hero Section */}
      <Element name="home">
        <section className="hero-section min-vh-100 d-flex align-items-center">
          <Container>
            <Row className="align-items-center">
              <Col lg={6} className="order-lg-1 order-2">
                <div className="hero-content">
                  <h1 className="display-4 fw-bold mb-4 text-primary animate__animated animate__fadeInUp">
                    Streamline Your Audit Process
                  </h1>
                  <p className="lead mb-4 text-muted animate__animated animate__fadeInUp animate__delay-1s">
                    Our comprehensive audit management solution helps you maintain compliance, 
                    reduce risks, and improve operational efficiency with ease.
                  </p>
                  <div className="d-flex flex-wrap gap-3 animate__animated animate__fadeInUp animate__delay-2s">
                    <Button 
                      variant="primary" 
                      size="lg" 
                      className="px-4 py-3 rounded-pill shadow-sm"
                      onClick={() => navigate('/RegisterTabs')} // Redirect to registration page
                    >
                      Start Free Trial
                    </Button>
                    {/* <Button 
                      variant="outline-primary" 
                      size="lg" 
                      className="px-4 py-3 rounded-pill shadow-sm"
                    >
                      Watch Demo
                    </Button> */}
                  </div>
                  
                </div>
              </Col>
              <Col lg={6} className="order-lg-2 order-1 mb-4 mb-lg-0">
                <div className="hero-image-container p-4  ">
                  <img 
                    src={heroImage}
                    alt="Audit Management Dashboard" 
                    className="img-fluid rounded shadow-lg" 
                    //style={{ transform: 'perspective(1000px) rotateY(-10deg)' }}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Element>

      {/* Other sections */}
      <Element name="overview">
        <Overview />
      </Element>

      <Element name="features">
        <Features />
      </Element>

      <Element name="pricing">
        <Pricing />
      </Element>

      <Element name="contact">
        <Contact />
      </Element>
    </div>
  );
};

export default HomePage;